/**
 * @spec docs/specs/features/staking-position-ui.md#framework-portability-patterns
 * Framework-agnostic route definitions
 *
 * Works with both React Router and Next.js Link.
 * Use these helpers everywhere instead of hardcoded paths.
 */

export const routes = {
  home: () => '/',
  address: (address: string) => `/address/${address}`,
  stake: () => '/stake',
  swap: () => '/swap',
  /** Swap page opened on USDC → PHNM (the "Buy PHNM" entry point). */
  buyPhnm: () => '/swap?direction=buy',
  /** CHIP withdrawal page (CHIP migration). */
  withdraw: () => '/withdraw',
  /** Lending (Credit Pool) coming-soon page with the interest sign-up form. */
  lending: () => '/lending',
} as const;

// Type helpers for route parameters
export type RouteParams = {
  address: { address: string };
};
